import { useEffect, useState } from "react";
import Router from "./router/Router";
import { menus as menusData } from "./data";
import { APIService } from "./http/http-common";

function App() {
  const [menus, setMenus] = useState({});
  const [setting, setSetting] = useState({});
  useEffect(() => {
    getHeaders();
  }, []);

  const getHeaders = () => {
      setMenus(menusData.pages);
      setSetting(menusData.settings.general);
    // Note: Old API way
    // APIService.get(`/menus`)
    //   .then((res) => {
    //     setMenus(res.data.data.pages);
    //     setSetting(res.data.data.settings.general);
    //   })
    //   .catch((err) => {});
  };

  return (
    <>
      {/* Router starts */}
      <Router menuData={menus} settingData={setting} />
    </>
  );
}

export default App;
